import { Box, Chip, Typography } from '@mui/material';
import { styled } from '@mui/styles';

export const WorkFormRequiredCertificates = ({
  certificates,
}: {
  certificates:
    | {
        id: string;
        name: string;
      }[]
    | undefined;
}) => {
  if (!certificates || !certificates.length) {
    return null;
  }
  return (
    <CertificatesContainer>
      <Typography variant="subtitle2" color="secondary">
        Certificaten *
      </Typography>
      <CertificatesList>
        {certificates.map((certificate) => (
          <Chip
            key={certificate.id}
            label={certificate.name}
            variant="outlined"
            sx={{
              padding: 'unset',
            }}
          />
        ))}
      </CertificatesList>
    </CertificatesContainer>
  );
};

const CertificatesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  flexDirection: 'column',
}));

const CertificatesList = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(2),
  flexDirection: 'row',
}));
